import { Tag } from 'antd';

import type { CertVendor } from '../../redux/api/material-certs';
import { VENDORS } from './buckets';

/**
 * Who sent the paperwork. Alro and McMaster documents share one queue but
 * join differently (heat vs PO line), so the vendor travels with the PO.
 */
export default function VendorTag({
	vendors,
}: {
	vendors: CertVendor[] | undefined;
}) {
	return (
		<>
			{(vendors ?? []).map((vendor) => (
				<Tag
					key={vendor}
					color={VENDORS[vendor]?.color ?? 'default'}
					style={{ marginInlineEnd: 0 }}
				>
					{VENDORS[vendor]?.label ?? vendor}
				</Tag>
			))}
		</>
	);
}
